/**
 * HEX to Pantone Solid Coated Converter
 * Finds the closest Pantone Solid Coated match for a given HEX color.
 */

(function () {
  // Pantone Solid Coated color reference data: [name, hex]
  const PANTONE_COLORS = [
    ["Yellow C", "FEDD00"], ["Yellow 012 C", "FFD700"], ["Orange 021 C", "FE5000"],
    ["Warm Red C", "F9423A"], ["Red 032 C", "EF3340"], ["Rubine Red C", "CE0058"],
    ["Rhodamine Red C", "E10098"], ["Purple C", "BB29BB"], ["Violet C", "440099"],
    ["Blue 072 C", "10069F"], ["Reflex Blue C", "001489"], ["Process Blue C", "0085CA"],
    ["Green C", "00AB84"], ["Black C", "2D2926"], ["Cool Gray 1 C", "D9D9D6"],
    ["Cool Gray 2 C", "D0D0CE"], ["Cool Gray 3 C", "C8C9C7"], ["Cool Gray 4 C", "BBBCBC"],
    ["Cool Gray 5 C", "B1B3B3"], ["Cool Gray 6 C", "A7A8AA"], ["Cool Gray 7 C", "97999B"],
    ["Cool Gray 8 C", "888B8D"], ["Cool Gray 9 C", "75787B"], ["Cool Gray 10 C", "63666A"],
    ["Cool Gray 11 C", "53565A"], ["Warm Gray 1 C", "D7D2CB"], ["Warm Gray 2 C", "CBC4BC"],
    ["Warm Gray 3 C", "BFB8AF"], ["Warm Gray 4 C", "B6ADA5"], ["Warm Gray 5 C", "ACA39A"],
    ["Warm Gray 6 C", "A59C94"], ["Warm Gray 7 C", "968C83"], ["Warm Gray 8 C", "8C8279"],
    ["Warm Gray 9 C", "83786F"], ["Warm Gray 10 C", "796E65"], ["Warm Gray 11 C", "6E6259"],
    ["100 C", "F6EB61"], ["101 C", "F7EA48"], ["102 C", "FCE300"],
    ["103 C", "C5A900"], ["104 C", "AF9800"], ["105 C", "897A27"],
    ["106 C", "F9E547"], ["107 C", "F9E526"], ["108 C", "FEDB00"],
    ["109 C", "FFD100"], ["110 C", "DAAA00"], ["111 C", "AA8A00"],
    ["112 C", "9C8412"], ["113 C", "FAE053"], ["114 C", "F9DE4D"],
    ["115 C", "FBDB65"], ["116 C", "FFCD00"], ["117 C", "C99700"],
    ["118 C", "E0A526"], ["119 C", "896D2F"], ["120 C", "FBDB93"],
    ["121 C", "FBD872"], ["122 C", "FED141"], ["123 C", "FFC72C"],
    ["124 C", "EAAA00"], ["125 C", "B58500"], ["126 C", "9E7A38"],
    ["127 C", "F3DD6D"], ["128 C", "F3D54E"], ["129 C", "F3CF45"],
    ["130 C", "F2A900"], ["131 C", "CC8A00"], ["132 C", "A07400"],
    ["133 C", "6C571B"], ["134 C", "FDD26E"], ["135 C", "FFC658"],
    ["136 C", "FFBC49"], ["137 C", "FFA300"], ["138 C", "DE7C00"],
    ["139 C", "AF6D04"], ["140 C", "7A5B25"], ["141 C", "F2C75C"],
    ["142 C", "F1BE48"], ["143 C", "EFB22D"], ["144 C", "ED8B00"],
    ["145 C", "CF7F00"], ["146 C", "A76D11"], ["147 C", "715C2A"],
    ["148 C", "FCCB8B"], ["149 C", "FCC17B"], ["150 C", "FFB25B"],
    ["151 C", "FF8200"], ["152 C", "E57200"], ["153 C", "BE6A14"],
    ["154 C", "9B5A1A"], ["155 C", "EFD19F"], ["156 C", "EFBE7D"],
    ["157 C", "ECA154"], ["158 C", "E87511"], ["159 C", "CB6015"],
    ["160 C", "A1561C"], ["161 C", "603D20"], ["162 C", "FFBE9F"],
    ["163 C", "FF9D6E"], ["164 C", "FF7F41"], ["165 C", "FF6720"],
    ["166 C", "E35205"], ["167 C", "BE4D00"], ["168 C", "73381D"],
    ["169 C", "FFB3AB"], ["170 C", "FF8674"], ["171 C", "FF6A4D"],
    ["172 C", "FF5C35"], ["173 C", "CF4520"], ["174 C", "963821"],
    ["175 C", "6B3529"], ["176 C", "FFADAD"], ["177 C", "FF8DA1"],
    ["178 C", "FF585D"], ["179 C", "E03C31"], ["180 C", "C13828"],
    ["181 C", "81312F"], ["182 C", "FABBCB"], ["183 C", "FC9BB3"],
    ["184 C", "F65275"], ["185 C", "E4002B"], ["186 C", "C8102E"],
    ["187 C", "A6192E"], ["188 C", "76232F"], ["189 C", "FFA3B5"],
    ["190 C", "F8718D"], ["191 C", "F04E62"], ["192 C", "E40046"],
    ["193 C", "BF0D3E"], ["194 C", "99233C"], ["195 C", "7C2439"],
    ["196 C", "EFC4C2"], ["197 C", "EF8B90"], ["198 C", "DF2E48"],
    ["199 C", "D50032"], ["200 C", "BA0C2F"], ["201 C", "9B2335"],
    ["202 C", "862633"], ["203 C", "ECB3CB"], ["204 C", "E782A9"],
    ["205 C", "E0457B"], ["206 C", "D0006F"], ["207 C", "A50050"],
    ["208 C", "8E2344"], ["209 C", "6F263D"], ["210 C", "FFA0BF"],
    ["211 C", "FF77A0"], ["212 C", "F04F78"], ["213 C", "E31C79"],
    ["214 C", "CC0C6B"], ["215 C", "AC145A"], ["216 C", "7C2348"],
    ["217 C", "EABECD"], ["218 C", "E56AAD"], ["219 C", "DA1884"],
    ["220 C", "A50050"], ["221 C", "910048"], ["222 C", "6C2049"],
    ["223 C", "F57EB6"], ["224 C", "F04DA1"], ["225 C", "E5007D"],
    ["226 C", "D60270"], ["227 C", "AA0061"], ["228 C", "830051"],
    ["229 C", "672146"], ["230 C", "FFA3D1"], ["231 C", "F26DB7"],
    ["232 C", "E93CAC"], ["233 C", "CE007C"], ["234 C", "A20067"],
    ["235 C", "840B55"], ["236 C", "F9A1D8"], ["237 C", "F264AB"],
    ["238 C", "E44C9A"], ["239 C", "D61F86"], ["240 C", "C5007F"],
    ["241 C", "AF0073"], ["242 C", "7E2D6E"], ["243 C", "F0A1BF"],
    ["244 C", "EF82B1"], ["245 C", "E968A4"], ["246 C", "CC00A0"],
    ["247 C", "BB0090"], ["248 C", "A40084"], ["249 C", "7C2763"],
    ["250 C", "EDA7D2"], ["251 C", "E56DB1"], ["252 C", "D33FA1"],
    ["253 C", "AF1685"], ["254 C", "A01476"], ["255 C", "7E2563"],
    ["256 C", "DFBFD1"], ["257 C", "CB91B5"], ["258 C", "90499C"],
    ["259 C", "6C1D5F"], ["260 C", "681E5D"], ["261 C", "5E1B56"],
    ["262 C", "512A44"], ["263 C", "D7C6E6"], ["264 C", "C1A0DA"],
    ["265 C", "9063CD"], ["266 C", "7544B1"], ["267 C", "59118E"],
    ["268 C", "4F2C7E"], ["269 C", "3D1F56"], ["270 C", "B4A7D6"],
    ["271 C", "9D8EC7"], ["272 C", "7D67B5"], ["273 C", "311B72"],
    ["274 C", "2B1A6B"], ["275 C", "261659"], ["276 C", "221551"],
    ["277 C", "ABCAE9"], ["278 C", "8BB8E8"], ["279 C", "418FDE"],
    ["280 C", "012169"], ["281 C", "00205B"], ["282 C", "041E42"],
    ["283 C", "92C1E9"], ["284 C", "6CACE4"], ["285 C", "0072CE"],
    ["286 C", "0033A0"], ["287 C", "003DA5"], ["288 C", "002D72"],
    ["289 C", "0C2340"], ["290 C", "B9D9EB"], ["291 C", "A2C8E0"],
    ["292 C", "69B3E7"], ["293 C", "003DA5"], ["294 C", "002F6C"],
    ["295 C", "003B5C"], ["296 C", "041C2C"], ["297 C", "71C5E8"],
    ["298 C", "41B6E6"], ["299 C", "00A3E0"], ["300 C", "005EB8"],
    ["301 C", "004B87"], ["302 C", "003B5C"], ["303 C", "002A3A"],
    ["304 C", "A4DBE8"], ["305 C", "70CDE3"], ["306 C", "00B5E2"],
    ["307 C", "006298"], ["308 C", "00587C"], ["309 C", "003B49"],
    ["310 C", "6AD1E3"], ["311 C", "08B1D5"], ["312 C", "00A9CE"],
    ["313 C", "0092BC"], ["314 C", "00789E"], ["315 C", "005F7F"],
    ["316 C", "003946"], ["317 C", "B1E4E3"], ["318 C", "88DBDF"],
    ["319 C", "2DCCD3"], ["320 C", "009CA6"], ["321 C", "008C95"],
    ["322 C", "007680"], ["323 C", "005E6E"], ["324 C", "9ADBD8"],
    ["325 C", "64CCC9"], ["326 C", "00B2A9"], ["327 C", "008675"],
    ["328 C", "007B6F"], ["329 C", "006F62"], ["330 C", "005C5D"],
    ["331 C", "A6E9D6"], ["332 C", "89E4CD"], ["333 C", "3CDBC0"],
    ["334 C", "009B74"], ["335 C", "007C5E"], ["336 C", "006A52"],
    ["337 C", "8FD6BD"], ["338 C", "6ECEB2"], ["339 C", "00B388"],
    ["340 C", "00965E"], ["341 C", "007A4D"], ["342 C", "006845"],
    ["343 C", "115740"], ["344 C", "A0DAB3"], ["345 C", "7FCC9B"],
    ["346 C", "56C271"], ["347 C", "009A44"], ["348 C", "007A33"],
    ["349 C", "046A38"], ["350 C", "2C5234"], ["351 C", "A2E4B8"],
    ["352 C", "8FE2B0"], ["353 C", "80E0A7"], ["354 C", "00B140"],
    ["355 C", "009639"], ["356 C", "007A33"], ["357 C", "215732"],
    ["358 C", "ADDC91"], ["359 C", "A1D884"], ["360 C", "6CC24A"],
    ["361 C", "43B02A"], ["362 C", "339E35"], ["363 C", "2C8C30"],
    ["364 C", "3A7728"], ["365 C", "C2E189"], ["366 C", "B7DD79"],
    ["367 C", "A4D65E"], ["368 C", "78BE20"], ["369 C", "64A70B"],
    ["370 C", "568F23"], ["371 C", "4A6C2F"], ["372 C", "D4EC86"],
    ["373 C", "CEEA82"], ["374 C", "C0E457"], ["375 C", "97D700"],
    ["376 C", "84BD00"], ["377 C", "6F9B28"], ["378 C", "566B21"],
    ["379 C", "E0E721"], ["380 C", "D4DE26"], ["381 C", "CEDC00"],
    ["382 C", "C4D600"], ["383 C", "A8AD00"], ["384 C", "949300"],
    ["385 C", "787121"], ["386 C", "E8E44D"], ["387 C", "E0E43F"],
    ["388 C", "D5D717"], ["389 C", "C9DA2A"], ["390 C", "B5BD00"],
    ["391 C", "9A9500"], ["392 C", "827A04"], ["393 C", "F0EB6A"],
    ["394 C", "EDEA38"], ["395 C", "EAE600"], ["396 C", "E1E000"],
    ["397 C", "C0BF00"], ["398 C", "ADA400"], ["399 C", "938D00"],
    ["400 C", "C4BFB6"], ["401 C", "AFA89F"], ["402 C", "A39E93"],
    ["403 C", "8E8279"], ["404 C", "776E64"], ["405 C", "696158"],
    ["406 C", "C7C2B8"], ["407 C", "B2A8A2"], ["408 C", "A09D97"],
    ["409 C", "928E86"], ["410 C", "7B7670"], ["411 C", "635D59"],
    ["412 C", "3D3935"], ["413 C", "BABFB1"], ["414 C", "A5AB9E"],
    ["415 C", "919388"], ["416 C", "7C7F72"], ["417 C", "65665C"],
    ["418 C", "585C52"], ["419 C", "212721"],
    ["420 C", "C7C9C7"], ["421 C", "B0B7B3"], ["422 C", "9EA2A2"],
    ["423 C", "898D8D"], ["424 C", "707372"], ["425 C", "545859"],
    ["426 C", "25282A"],
    ["427 C", "D0D3D4"], ["428 C", "C1C6C8"], ["429 C", "A2AAAD"],
    ["430 C", "7C878E"], ["431 C", "5B6770"], ["432 C", "333F48"],
    ["433 C", "1D252D"],
    ["434 C", "D1C0B4"], ["435 C", "C2A992"], ["436 C", "AD9984"],
    ["437 C", "7A6855"], ["438 C", "4B3D2A"], ["439 C", "3B302A"],
    ["440 C", "382F2D"],
    ["441 C", "BFC0BC"], ["442 C", "A9ADAA"], ["443 C", "919693"],
    ["444 C", "717573"], ["445 C", "565A5C"], ["446 C", "494C4E"],
    ["447 C", "373A36"],
    ["448 C", "4A412A"], ["449 C", "524727"], ["450 C", "5E5B2D"],
    ["451 C", "9B945F"], ["452 C", "B3AE6E"], ["453 C", "BFB873"],
    ["454 C", "C9C07E"],
    ["455 C", "665E1E"], ["456 C", "9A8419"], ["457 C", "B58B00"],
    ["458 C", "DDCB6B"], ["459 C", "E0CC5B"], ["460 C", "E3CC81"],
    ["461 C", "E9D99A"],
    ["462 C", "5C462B"], ["463 C", "6F4F28"], ["464 C", "825D24"],
    ["465 C", "B89D5B"], ["466 C", "C6AA76"], ["467 C", "CDB48C"],
    ["468 C", "DDCBA4"],
    ["469 C", "693F23"], ["470 C", "9E5B2E"], ["471 C", "B86125"],
    ["472 C", "E09E60"], ["473 C", "E8B580"], ["474 C", "EDBD8B"],
    ["475 C", "F0C8A0"],
    ["476 C", "4E3629"], ["477 C", "623B2A"], ["478 C", "6D3B24"],
    ["479 C", "AD8B65"], ["480 C", "C9A86C"], ["481 C", "D1B882"],
    ["482 C", "DCC99E"],
    ["483 C", "6B3023"], ["484 C", "9A3324"], ["485 C", "DA291C"],
    ["486 C", "E8755A"], ["487 C", "EE9765"], ["488 C", "ECAA79"],
    ["489 C", "EDB98A"],
    ["490 C", "5D2A2C"], ["491 C", "7F3035"], ["492 C", "8F3237"],
    ["493 C", "DC8695"], ["494 C", "F2ACB9"], ["495 C", "F4B8C8"],
    ["496 C", "F5C7D3"],
    ["497 C", "512F2E"], ["498 C", "6A3735"], ["499 C", "7A382D"],
    ["500 C", "CD8C95"], ["501 C", "E3ABB2"], ["502 C", "EBBFC3"],
    ["503 C", "F0C9CD"],
    ["504 C", "572932"], ["505 C", "80304C"], ["506 C", "84344E"],
    ["507 C", "D592AA"], ["508 C", "E3AEC4"], ["509 C", "E9BFCD"],
    ["510 C", "EDCCD4"],
    ["511 C", "612C51"], ["512 C", "833177"], ["513 C", "933EA5"],
    ["514 C", "DC8ACB"], ["515 C", "E6ADDB"], ["516 C", "ECBFE1"],
    ["517 C", "F0C9E2"],
    ["518 C", "513750"], ["519 C", "59315F"], ["520 C", "66306E"],
    ["521 C", "B596C8"], ["522 C", "A07DB5"], ["523 C", "8C69A5"],
    ["524 C", "C6B5D2"],
    ["525 C", "622A76"], ["526 C", "702F8A"], ["527 C", "7030A0"],
    ["528 C", "B5A4CF"], ["529 C", "C7B5E0"], ["530 C", "D0C2E1"],
    ["531 C", "D7C4E0"],
    ["532 C", "1C1F2A"], ["533 C", "202A44"], ["534 C", "1B3668"],
    ["535 C", "9CADB7"], ["536 C", "ADB8CA"], ["537 C", "C4CAD0"],
    ["538 C", "C6CFDB"],
    ["539 C", "003050"], ["540 C", "003B5C"], ["541 C", "003C71"],
    ["542 C", "64A0C8"], ["543 C", "86B8DC"], ["544 C", "9DC3E0"],
    ["545 C", "B7D4E8"],
    ["546 C", "0C3524"], ["547 C", "003F2D"], ["548 C", "004438"],
    ["549 C", "6BAAAB"], ["550 C", "87B6AD"], ["551 C", "A2C3B2"],
    ["552 C", "B8CFB9"],
    ["553 C", "214332"], ["554 C", "205C40"], ["555 C", "28603D"],
    ["556 C", "7FA58D"], ["557 C", "85C5A1"], ["558 C", "9EC9AA"],
    ["559 C", "ACD5B1"],
    ["560 C", "1D3C34"], ["561 C", "006B54"], ["562 C", "007358"],
    ["563 C", "7DD1B3"], ["564 C", "86D8C9"], ["565 C", "A0DED4"],
    ["566 C", "BDDED6"],
    ["567 C", "173F35"], ["568 C", "006854"], ["569 C", "00856A"],
    ["570 C", "74E0C4"], ["571 C", "98E8D2"], ["572 C", "A5E7D4"],
    ["573 C", "B5EDE0"],
    ["574 C", "4E5B31"], ["575 C", "5C7430"], ["576 C", "5E8732"],
    ["577 C", "B3C98B"], ["578 C", "B7CE95"], ["579 C", "BFD09E"],
    ["580 C", "C4D6A0"],
    ["581 C", "605E20"], ["582 C", "8E8C13"], ["583 C", "B7BF10"],
    ["584 C", "D2DB2A"], ["585 C", "DBE442"], ["586 C", "E0E753"],
    ["587 C", "E4EB7C"],
    ["600 C", "F0EC74"], ["601 C", "F0EC68"], ["602 C", "F0EB58"],
    ["603 C", "EDE939"], ["604 C", "E5E11E"], ["605 C", "D3CE00"],
    ["606 C", "C1BC00"],
    ["607 C", "EBE76E"], ["608 C", "E8E34D"], ["609 C", "E4DF30"],
    ["610 C", "D9D300"], ["611 C", "C4BE00"], ["612 C", "B4A900"],
    ["613 C", "9E8F00"],
    ["614 C", "DDD595"], ["615 C", "D1C87B"], ["616 C", "C4BB61"],
    ["617 C", "AFA23E"], ["618 C", "918727"], ["619 C", "7E6F20"],
    ["620 C", "6B5D1E"],
    ["621 C", "C8D7C2"], ["622 C", "ADC2A9"], ["623 C", "8FAF8A"],
    ["624 C", "6E9A6E"], ["625 C", "507E53"], ["626 C", "285C4D"],
    ["627 C", "13322B"],
    ["628 C", "86D1DD"], ["629 C", "6EC9D6"], ["630 C", "3CBCC1"],
    ["631 C", "00A3AD"], ["632 C", "0093A3"], ["633 C", "007C91"],
    ["634 C", "006B7F"],
    ["635 C", "7ED3E5"], ["636 C", "5BC2E7"], ["637 C", "27BDBE"],
    ["638 C", "00B0BD"], ["639 C", "00A3AD"], ["640 C", "008DA1"],
    ["641 C", "00748B"],
    ["642 C", "BACEE0"], ["643 C", "9BBBDE"], ["644 C", "6787B7"],
    ["645 C", "5B7FA5"], ["646 C", "5E7FA3"], ["647 C", "236192"],
    ["648 C", "002B5C"],
    ["649 C", "CDD5E5"], ["650 C", "AFC1D6"], ["651 C", "7D9BC1"],
    ["652 C", "5B82A7"], ["653 C", "32608A"], ["654 C", "003A70"],
    ["655 C", "002855"],
    ["656 C", "D3DBE8"], ["657 C", "B6C4DC"], ["658 C", "8FA9CB"],
    ["659 C", "5C82A5"], ["660 C", "4570A5"], ["661 C", "003472"],
    ["662 C", "001A57"],
    ["663 C", "D1CACC"], ["664 C", "C2B7C2"], ["665 C", "A497AF"],
    ["666 C", "91779E"], ["667 C", "6D5685"], ["668 C", "614B79"],
    ["669 C", "3F2A56"],
    ["670 C", "EABABC"], ["671 C", "E8A5C0"], ["672 C", "DF82A6"],
    ["673 C", "D96AA5"], ["674 C", "C2518E"], ["675 C", "AE2573"],
    ["676 C", "960051"],
    ["677 C", "E8CBCB"], ["678 C", "E5B6BB"], ["679 C", "E09BA4"],
    ["680 C", "C36376"], ["681 C", "A94E67"], ["682 C", "92415F"],
    ["683 C", "7C2D4C"],
    ["684 C", "E5BFCB"], ["685 C", "DCA5B5"], ["686 C", "CE8BA3"],
    ["687 C", "BA4D7C"], ["688 C", "A8326E"], ["689 C", "812A60"],
    ["690 C", "641F45"],
    ["691 C", "EBC9C0"], ["692 C", "E3B3AA"], ["693 C", "D69088"],
    ["694 C", "C26A66"], ["695 C", "A94B50"], ["696 C", "904040"],
    ["697 C", "7D2E37"],
    ["698 C", "F4C9C9"], ["699 C", "F2A9B0"], ["700 C", "ED7C7A"],
    ["701 C", "E25B62"], ["702 C", "D12F3B"], ["703 C", "B71234"],
    ["704 C", "9E1B32"],
    ["705 C", "F4D4D0"], ["706 C", "F7BCC4"], ["707 C", "F28FAA"],
    ["708 C", "F06C9B"], ["709 C", "E64C83"], ["710 C", "D42E6B"],
    ["711 C", "CB2C69"],
    ["712 C", "FFC362"], ["713 C", "FFB549"], ["714 C", "FDAA34"],
    ["715 C", "F68D2E"], ["716 C", "ED7117"], ["717 C", "D35F12"],
    ["718 C", "BE5400"],
    ["719 C", "EDCF8E"], ["720 C", "E2BA73"], ["721 C", "D4A055"],
    ["722 C", "B57C2D"], ["723 C", "A66B1F"], ["724 C", "925418"],
    ["725 C", "7C4719"],
    ["726 C", "D9C89E"], ["727 C", "C8A86C"], ["728 C", "B08F4A"],
    ["729 C", "9A7D2E"], ["730 C", "8A6F28"], ["731 C", "6B4714"],
    ["732 C", "53380D"],
    ["1205 C", "F9E28E"], ["1215 C", "FBD367"], ["1225 C", "FFBF3F"],
    ["1235 C", "F5A623"], ["1245 C", "C38B2D"], ["1255 C", "AD8419"],
    ["1265 C", "896E2C"],
    ["1345 C", "FDC87D"], ["1355 C", "FCBA6A"], ["1365 C", "FCA947"],
    ["1375 C", "FF9E1B"], ["1385 C", "D67E1B"], ["1395 C", "AC5F16"],
    ["1405 C", "7D4718"],
    ["1485 C", "FFA167"], ["1495 C", "FF8B3D"], ["1505 C", "FF6A13"],
    ["1525 C", "BF4B00"], ["1535 C", "943D0C"], ["1545 C", "602E14"],
    ["1555 C", "FF9F6C"],
    ["1565 C", "FF8247"], ["1575 C", "FF6F2B"], ["1585 C", "FF5E00"],
    ["1595 C", "C54C00"], ["1605 C", "8D3F19"], ["1615 C", "6E3219"],
    ["1625 C", "FF7477"],
    ["1635 C", "FF5C5C"], ["1645 C", "FF3B30"], ["1655 C", "E0301E"],
    ["1665 C", "B62F21"], ["1675 C", "8C3420"], ["1685 C", "6F3222"],
    ["1695 C", "7D332A"],
    ["1765 C", "FF8FA4"], ["1767 C", "FCAFC0"], ["1775 C", "FF8DA1"],
    ["1785 C", "F4364C"], ["1788 C", "EE2737"], ["1795 C", "D22630"],
    ["1797 C", "CB333B"],
    ["1805 C", "AF272F"], ["1807 C", "A4343A"], ["1815 C", "7C2128"],
    ["1817 C", "5C3832"],
    ["1895 C", "F5A6C8"], ["1905 C", "F49AC1"], ["1915 C", "EF4A81"],
    ["1925 C", "E00747"], ["1935 C", "C5003E"], ["1945 C", "A6093D"],
    ["1955 C", "8E1339"],
    ["2365 C", "E6BEDD"], ["2375 C", "CC5FBC"], ["2385 C", "C048AC"],
    ["2395 C", "A6228E"], ["2405 C", "8A1279"], ["2415 C", "770E68"],
    ["2425 C", "5F0F4E"],
    ["2562 C", "C59AC8"], ["2563 C", "C17DC2"], ["2567 C", "B58FC2"],
    ["2572 C", "AE6FC2"], ["2573 C", "A26DC3"], ["2577 C", "9B6FBF"],
    ["2582 C", "984B98"],
    ["2583 C", "904098"], ["2587 C", "7D4F91"], ["2592 C", "85329A"],
    ["2593 C", "7B2D8E"], ["2597 C", "5C0F8B"], ["2602 C", "76207F"],
    ["2603 C", "6D2077"],
    ["2607 C", "500878"], ["2612 C", "6C2373"], ["2613 C", "6C1F77"],
    ["2617 C", "5D0F73"], ["2622 C", "602F6B"], ["2623 C", "5E2571"],
    ["2627 C", "4D1368"],
    ["2635 C", "8F82C0"], ["2645 C", "7B6DB5"], ["2655 C", "6654A6"],
    ["2665 C", "5B3FA3"], ["2685 C", "3F1886"], ["2695 C", "321159"],
    ["2706 C", "ADC3E0"],
    ["2707 C", "93B7D6"], ["2708 C", "6694C6"], ["2715 C", "6687C7"],
    ["2716 C", "5570B5"], ["2718 C", "3A5DAE"], ["2725 C", "524FA1"],
    ["2726 C", "485CC7"],
    ["2727 C", "2E5BAE"], ["2728 C", "0047BB"], ["2735 C", "3F2893"],
    ["2736 C", "3633A0"], ["2738 C", "2D1F8E"], ["2745 C", "3A2D7C"],
    ["2746 C", "353080"],
    ["2747 C", "1E1A6E"], ["2748 C", "1B1A5C"], ["2755 C", "2D338B"],
    ["2756 C", "262B6F"], ["2757 C", "1F2554"], ["2758 C", "1A2155"],
    ["2765 C", "231C50"],
    ["2766 C", "1D1A51"], ["2767 C", "13294B"],
    ["2905 C", "6ECFEB"], ["2915 C", "58C7E6"], ["2925 C", "009CDE"],
    ["2935 C", "0057B8"], ["2945 C", "004F9F"], ["2955 C", "003865"],
    ["2965 C", "00305A"],
    ["2975 C", "99D6EA"], ["2985 C", "44C8F5"], ["2995 C", "00A9E0"],
    ["3005 C", "0077C8"], ["3015 C", "00629B"], ["3025 C", "005776"],
    ["3035 C", "004C6D"],
    ["3105 C", "64CDD5"], ["3115 C", "00C1D5"], ["3125 C", "00B4D2"],
    ["3135 C", "008EAA"], ["3145 C", "00788A"], ["3155 C", "006272"],
    ["3165 C", "005566"],
    ["3242 C", "53D3C9"], ["3245 C", "63DBD4"], ["3248 C", "42C2AA"],
    ["3252 C", "56D9BF"], ["3255 C", "33D4AD"], ["3258 C", "3EB89A"],
    ["3262 C", "00BFA5"],
    ["3265 C", "00CF9F"], ["3268 C", "00A87D"], ["3272 C", "009B8D"],
    ["3275 C", "00BD85"], ["3278 C", "009E73"], ["3282 C", "008778"],
    ["3285 C", "00B28B"],
    ["3288 C", "00945D"], ["3292 C", "006B5E"], ["3295 C", "009A66"],
    ["3298 C", "006F51"], ["3302 C", "005040"],
    ["3305 C", "004C3F"], ["3308 C", "034638"],
    ["3375 C", "79E7B7"], ["3385 C", "48D597"], ["3395 C", "00C96F"],
    ["3405 C", "00AF66"], ["3415 C", "007B48"], ["3425 C", "006B3F"],
    ["3435 C", "154734"],
    ["3516 C", "D2E288"], ["3526 C", "C4DA59"], ["3536 C", "A9C637"],
    ["3546 C", "83AE1E"], ["3556 C", "6E9E1E"], ["3566 C", "608E1E"],
    ["3576 C", "4E7D20"],
    ["3935 C", "F1E85E"], ["3945 C", "F1E540"], ["3955 C", "EFE024"],
    ["3965 C", "ECDA18"], ["3975 C", "B8A500"], ["3985 C", "9B8800"],
    ["3995 C", "6E6512"],
    ["4485 C", "5F4B2F"], ["4495 C", "71603E"], ["4505 C", "827343"],
    ["4515 C", "AB9959"], ["4525 C", "B39B58"], ["4535 C", "C6B06B"],
    ["4545 C", "D1BD7C"],
    ["4625 C", "4C2216"], ["4635 C", "8C5E35"], ["4645 C", "A67A4B"],
    ["4655 C", "B58A5D"], ["4665 C", "C89F6E"], ["4675 C", "CDA97C"],
    ["4685 C", "D4B48E"],
    ["4695 C", "4F2C1D"], ["4705 C", "6E4430"], ["4715 C", "865640"],
    ["4725 C", "A07450"], ["4735 C", "B48A67"], ["4745 C", "BF9474"],
    ["4755 C", "CB9E7C"],
    ["4975 C", "3F2021"], ["4985 C", "6B3D3A"], ["4995 C", "814B4B"],
    ["5005 C", "955754"], ["5015 C", "AE7A6E"], ["5025 C", "B78A7D"],
    ["5035 C", "C79C90"],
    ["5105 C", "6B4061"], ["5115 C", "6B3E6A"], ["5125 C", "7C5279"],
    ["5135 C", "956687"], ["5145 C", "A97C93"], ["5155 C", "BD96A7"],
    ["5165 C", "CFA6B9"],
    ["5185 C", "30243B"], ["5195 C", "44304B"], ["5205 C", "6B4758"],
    ["5215 C", "917079"], ["5225 C", "A67E85"], ["5235 C", "B99095"],
    ["5245 C", "C9A2A1"],
    ["5255 C", "242350"], ["5265 C", "2F2A5C"], ["5275 C", "393266"],
    ["5285 C", "6B5E8D"], ["5295 C", "7D6FA3"], ["5305 C", "9E95BA"],
    ["5315 C", "B6AAC8"],
    ["5395 C", "0E1C3A"], ["5405 C", "4F7695"], ["5415 C", "5C849B"],
    ["5425 C", "7A9AAC"], ["5435 C", "97B5C2"], ["5445 C", "A8C5D0"],
    ["5455 C", "B7CED6"],
    ["5467 C", "18453B"], ["5477 C", "2C6C5A"], ["5487 C", "5E8978"],
    ["5497 C", "769D8B"], ["5507 C", "8BACA0"], ["5517 C", "A1BAAE"],
    ["5527 C", "ADC1B4"],
    ["5535 C", "213D30"], ["5545 C", "4B7B5E"], ["5555 C", "5E8B69"],
    ["5565 C", "7EA380"], ["5575 C", "91B392"], ["5585 C", "A7C0A1"],
    ["5595 C", "B6CCB1"],
    ["5605 C", "233A2C"], ["5615 C", "5A7C5E"], ["5625 C", "6B8E5A"],
    ["5635 C", "8FAF6F"], ["5645 C", "A1BB80"], ["5655 C", "B3C98B"],
    ["5665 C", "BBC792"],
    ["5743 C", "3E4827"], ["5747 C", "3F5828"], ["5753 C", "5F6733"],
    ["5757 C", "6A753B"], ["5763 C", "817B3C"], ["5767 C", "9AA044"],
    ["5773 C", "89813D"],
    ["5777 C", "A5AE54"], ["5783 C", "9A9148"], ["5787 C", "C1C561"],
    ["5793 C", "A69F50"], ["5797 C", "C9CB51"],
    ["5803 C", "ADA955"], ["5807 C", "D1D33C"],
    ["7401 C", "F5E1A4"], ["7402 C", "EBD469"], ["7403 C", "EACA2A"],
    ["7404 C", "F5D918"], ["7405 C", "F6D201"], ["7406 C", "F1C400"],
    ["7407 C", "CDA343"],
    ["7408 C", "F0AB00"], ["7409 C", "EEA400"], ["7410 C", "EDAA55"],
    ["7411 C", "E5A041"], ["7412 C", "D8922F"], ["7413 C", "DC871D"],
    ["7414 C", "CC7A2A"],
    ["7415 C", "E0C09F"], ["7416 C", "E5785E"], ["7417 C", "E2593E"],
    ["7418 C", "CD5060"], ["7419 C", "B63E5A"], ["7420 C", "A33050"],
    ["7421 C", "612141"],
    ["7422 C", "F1C3C0"], ["7423 C", "DE5578"], ["7424 C", "CA2E5E"],
    ["7425 C", "B02A56"], ["7426 C", "A01C42"], ["7427 C", "891635"],
    ["7428 C", "6C2240"],
    ["7429 C", "E0B3C2"], ["7430 C", "D49AB4"], ["7431 C", "C27F9D"],
    ["7432 C", "A05085"], ["7433 C", "932370"], ["7434 C", "7C1E5B"],
    ["7435 C", "69174E"],
    ["7436 C", "E3D3E4"], ["7437 C", "C4B1D4"], ["7438 C", "C390D4"],
    ["7439 C", "AE7AB5"], ["7440 C", "9A619C"], ["7441 C", "8E3FA1"],
    ["7442 C", "89009F"],
    ["7443 C", "D1CEE0"], ["7444 C", "B5B5D8"], ["7445 C", "9391C6"],
    ["7446 C", "7474C1"], ["7447 C", "5455A5"], ["7448 C", "374590"],
    ["7449 C", "1E2479"],
    ["7450 C", "BCCAD6"], ["7451 C", "6BBCDC"], ["7452 C", "6DADDB"],
    ["7453 C", "6DADE0"], ["7454 C", "52A2C4"], ["7455 C", "3A5DAB"],
    ["7456 C", "5F71BA"],
    ["7457 C", "B6D6E9"], ["7458 C", "71B2C9"], ["7459 C", "4298B5"],
    ["7460 C", "0076A5"], ["7461 C", "0073AE"], ["7462 C", "005C8A"],
    ["7463 C", "003050"],
    ["7464 C", "A1D6CA"], ["7465 C", "40C1AC"], ["7466 C", "00B0B9"],
    ["7467 C", "00A9A5"], ["7468 C", "00728F"], ["7469 C", "006685"],
    ["7470 C", "005A6C"],
    ["7471 C", "7DD6C7"], ["7472 C", "5AC0B0"], ["7473 C", "279989"],
    ["7474 C", "007A7C"], ["7475 C", "4F8A83"], ["7476 C", "005B5E"],
    ["7477 C", "244B5A"],
    ["7478 C", "A0D884"], ["7479 C", "54B948"], ["7480 C", "00B140"],
    ["7481 C", "00A84F"], ["7482 C", "009B3A"], ["7483 C", "275937"],
    ["7484 C", "005C46"],
    ["7485 C", "D3E0B7"], ["7486 C", "B5D89A"], ["7487 C", "6CC04A"],
    ["7488 C", "78BE21"], ["7489 C", "74AA50"], ["7490 C", "6D9A35"],
    ["7491 C", "8E9A3D"],
    ["7492 C", "B8CC72"], ["7493 C", "BFD87A"], ["7494 C", "9AB878"],
    ["7495 C", "8F993E"], ["7496 C", "76BC21"], ["7497 C", "B9C184"],
    ["7498 C", "739451"],
    ["7499 C", "F1E6B2"], ["7500 C", "D8CCAE"], ["7501 C", "D6C19A"],
    ["7502 C", "C7AB6E"], ["7503 C", "A78842"], ["7504 C", "946037"],
    ["7505 C", "7A4A2E"],
    ["7506 C", "F1DFC1"], ["7507 C", "F5CC7E"], ["7508 C", "E7B560"],
    ["7509 C", "D99938"], ["7510 C", "CE882B"], ["7511 C", "BC7824"],
    ["7512 C", "A76523"],
    ["7513 C", "E3C3A1"], ["7514 C", "D5A97C"], ["7515 C", "C6956A"],
    ["7516 C", "99552B"], ["7517 C", "8F4B25"], ["7518 C", "764137"],
    ["7519 C", "5E3629"],
    ["7520 C", "E8C4B8"], ["7521 C", "C5AFA4"], ["7522 C", "B4846C"],
    ["7523 C", "AB6B51"], ["7524 C", "A45A40"], ["7525 C", "956C58"],
    ["7526 C", "7B4931"],
    ["7527 C", "D6D2C4"], ["7528 C", "C7BFB2"], ["7529 C", "B5A899"],
    ["7530 C", "A39887"], ["7531 C", "8D7E72"], ["7532 C", "766A5E"],
    ["7533 C", "473B2B"],
    ["7534 C", "D1CCBF"], ["7535 C", "B5B0A1"], ["7536 C", "A59C8C"],
    ["7537 C", "ADBAB7"], ["7538 C", "A1ACA3"], ["7539 C", "8F9894"],
    ["7540 C", "4D5357"],
    ["7541 C", "D5E0E0"], ["7542 C", "A4BCC2"], ["7543 C", "97A7AF"],
    ["7544 C", "768C97"], ["7545 C", "5A7283"], ["7546 C", "3F5765"],
    ["7547 C", "233141"],
    ["7548 C", "FFC600"], ["7549 C", "FFB500"], ["7550 C", "D19000"],
    ["7551 C", "B47E00"], ["7552 C", "73531D"], ["7553 C", "5A4522"],
    ["7554 C", "4B3D2A"], ["7555 C", "D29F13"], ["7556 C", "B78B20"],
    ["7557 C", "9F7D23"], ["7558 C", "967126"], ["7559 C", "8F6A2A"],
    ["7560 C", "7D622E"], ["7561 C", "6C5D34"], ["7562 C", "BD9B60"],
    ["7563 C", "D69A2D"], ["7564 C", "DB8A06"], ["7565 C", "CD7925"],
    ["7566 C", "AD6433"], ["7567 C", "89532F"], ["7568 C", "775135"],
    ["7569 C", "D78825"], ["7570 C", "D3832B"], ["7571 C", "C67D30"],
    ["7572 C", "B67233"], ["7573 C", "A7662B"], ["7574 C", "9E6A38"],
    ["7575 C", "835D32"], ["7576 C", "DB864E"], ["7577 C", "E07E3C"],
    ["7578 C", "DC6B2F"], ["7579 C", "DC582A"], ["7580 C", "C05131"],
    ["7581 C", "864A33"], ["7582 C", "674736"], ["7583 C", "C4622D"],
    ["7584 C", "BA5826"], ["7585 C", "AF5C37"], ["7586 C", "9E5330"],
    ["7587 C", "924C2E"], ["7588 C", "7B4D35"], ["7589 C", "5C4738"],
    ["7590 C", "D4B59E"], ["7591 C", "C07D59"], ["7592 C", "B15533"],
    ["7593 C", "9D432C"], ["7594 C", "7C3A2D"], ["7595 C", "6B3D2E"],
    ["7596 C", "5C3D31"], ["7597 C", "D14124"], ["7598 C", "BD472A"],
    ["7599 C", "B33D26"], ["7600 C", "8D3F2B"], ["7601 C", "83412C"],
    ["7602 C", "7B4931"], ["7603 C", "674230"], ["7604 C", "E4D5D3"],
    ["7605 C", "E1BBB4"], ["7606 C", "D6938A"], ["7607 C", "C26E60"],
    ["7608 C", "A4493D"], ["7609 C", "823B34"], ["7610 C", "683431"],
    ["7611 C", "DDBCB0"], ["7612 C", "CA9A8E"], ["7613 C", "BC8A7E"],
    ["7614 C", "A37F74"], ["7615 C", "866761"], ["7616 C", "6B4C4C"],
    ["7617 C", "583D3E"], ["7618 C", "C66E4E"], ["7619 C", "C04C36"],
    ["7620 C", "B7312C"], ["7621 C", "AB2328"], ["7622 C", "93272C"],
    ["7623 C", "8A2A2B"], ["7624 C", "802F2D"], ["7625 C", "E1523D"],
    ["7626 C", "C63527"], ["7627 C", "A72B2A"], ["7628 C", "9E2A2B"],
    ["7629 C", "6D3332"], ["7630 C", "633231"], ["7631 C", "572D2D"],
    ["7632 C", "D6C9CA"], ["7633 C", "C4A4A7"], ["7634 C", "C16784"],
    ["7635 C", "C63663"], ["7636 C", "BC204B"], ["7637 C", "912F46"],
    ["7638 C", "7E2D40"], ["7639 C", "936D73"], ["7640 C", "934054"],
    ["7641 C", "8E2C48"], ["7642 C", "732E4A"], ["7643 C", "672E45"],
    ["7644 C", "582D40"], ["7645 C", "502B3A"], ["7646 C", "A56E87"],
    ["7647 C", "A83D72"], ["7648 C", "991E66"], ["7649 C", "8A1B61"],
    ["7650 C", "722257"], ["7651 C", "6A2A5B"], ["7652 C", "5E2751"],
    ["7653 C", "948794"], ["7654 C", "A2789C"], ["7655 C", "A15A95"],
    ["7656 C", "8E3A80"], ["7657 C", "6E2B62"], ["7658 C", "6A3460"],
    ["7659 C", "5D3754"], ["7660 C", "9991A4"], ["7661 C", "8D6E97"],
    ["7662 C", "7A4183"], ["7663 C", "6B3077"], ["7664 C", "653279"],
    ["7665 C", "5E366E"], ["7666 C", "5C4E63"], ["7667 C", "6E7CA0"],
    ["7668 C", "686E9F"], ["7669 C", "615E9B"], ["7670 C", "565294"],
    ["7671 C", "514689"], ["7672 C", "4C4184"], ["7673 C", "535486"],
    ["7674 C", "878CB4"], ["7675 C", "7C7FAB"], ["7676 C", "7566A0"],
    ["7677 C", "6F5091"], ["7678 C", "68478D"], ["7679 C", "563D82"],
    ["7680 C", "523178"], ["7681 C", "94A9CB"], ["7682 C", "6787B7"],
    ["7683 C", "426DA9"], ["7684 C", "385E9D"], ["7685 C", "2C5697"],
    ["7686 C", "1D4F91"], ["7687 C", "1D428A"], ["7688 C", "4698CB"],
    ["7689 C", "298FC2"], ["7690 C", "0076A8"], ["7691 C", "006298"],
    ["7692 C", "005587"], ["7693 C", "004976"], ["7694 C", "01426A"],
    ["7695 C", "7BA7BC"], ["7696 C", "6399AE"], ["7697 C", "4E87A0"],
    ["7698 C", "41748D"], ["7699 C", "34657F"], ["7700 C", "165C7D"],
    ["7701 C", "005776"], ["7702 C", "48A9C5"], ["7703 C", "009CBD"],
    ["7704 C", "0085AD"], ["7705 C", "007096"], ["7706 C", "006A8E"],
    ["7707 C", "00617F"], ["7708 C", "005670"], ["7709 C", "63B1BC"],
    ["7710 C", "00A7B5"], ["7711 C", "0097A9"], ["7712 C", "00859B"],
    ["7713 C", "007D8A"], ["7714 C", "007680"], ["7715 C", "006269"],
    ["7716 C", "00968F"], ["7717 C", "00857D"], ["7718 C", "007672"],
    ["7719 C", "006D68"], ["7720 C", "00635B"], ["7721 C", "005E5D"],
    ["7722 C", "005151"], ["7723 C", "50A684"], ["7724 C", "00966C"],
    ["7725 C", "008755"], ["7726 C", "007B4B"], ["7727 C", "006F44"],
    ["7728 C", "006845"], ["7729 C", "005844"], ["7730 C", "4B9560"],
    ["7731 C", "228848"], ["7732 C", "007A3E"], ["7733 C", "007041"],
    ["7734 C", "286140"], ["7735 C", "36573B"], ["7736 C", "395542"],
    ["7737 C", "6BA539"], ["7738 C", "48A23F"], ["7739 C", "319B42"],
    ["7740 C", "3A913F"], ["7741 C", "44883E"], ["7742 C", "4A773C"],
    ["7743 C", "44693D"], ["7744 C", "BABC16"], ["7745 C", "ABAD23"],
    ["7746 C", "999B30"], ["7747 C", "888D30"], ["7748 C", "7C8034"],
    ["7749 C", "727337"], ["7750 C", "656635"], ["7751 C", "CAB64B"],
    ["7752 C", "CFB023"], ["7753 C", "C1A01E"], ["7754 C", "A08629"],
    ["7755 C", "897630"], ["7756 C", "736635"], ["7757 C", "675E33"],
    ["7758 C", "D4C304"], ["7759 C", "C4B200"], ["7760 C", "91852C"],
    ["7761 C", "747136"], ["7762 C", "5D6439"], ["7763 C", "585C3B"],
    ["7764 C", "535435"], ["7765 C", "BBB323"], ["7766 C", "B4A91F"],
    ["7767 C", "AA9D2E"], ["7768 C", "8F7E35"], ["7769 C", "716135"],
    ["7770 C", "635939"], ["7771 C", "4E4934"],
    ["Bright Red C", "F93822"], ["Dark Blue C", "00239C"],
    ["Medium Yellow C", "FFD900"], ["Medium Purple C", "4E008E"],
    ["Bright Orange C", "FF5F00"], ["Strong Red C", "C60C30"],
    ["Medium Blue C", "0067A0"], ["Bright Green C", "00B74F"],
    ["Pink C", "D62598"], ["Medium Brown C", "65452E"],
    ["Teal C", "008882"],
    ["Neutral Black C", "222223"], ["White C", "FFFFFF"],
    ["Black 2 C", "332F21"], ["Black 3 C", "212721"],
    ["Black 4 C", "31261D"], ["Black 5 C", "3E3327"],
    ["Black 6 C", "101820"], ["Black 7 C", "3D3935"],
    ["Hexachrome Black C", "212721"],
    ["Hexachrome Cyan C", "00A3DF"], ["Hexachrome Green C", "00AB4F"],
    ["Hexachrome Magenta C", "CC0084"], ["Hexachrome Orange C", "FF7500"],
    ["Hexachrome Yellow C", "FFE800"],
  ];

  // Convert hex string to RGB
  function hexToRgb(hex) {
    hex = hex.replace(/^#/, '').toUpperCase();
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return { r, g, b };
  }

  // Convert RGB to LAB for perceptual color matching
  function rgbToLab(r, g, b) {
    // Normalize RGB to 0-1
    let rr = r / 255, gg = g / 255, bb = b / 255;

    // Linearize sRGB
    rr = rr > 0.04045 ? Math.pow((rr + 0.055) / 1.055, 2.4) : rr / 12.92;
    gg = gg > 0.04045 ? Math.pow((gg + 0.055) / 1.055, 2.4) : gg / 12.92;
    bb = bb > 0.04045 ? Math.pow((bb + 0.055) / 1.055, 2.4) : bb / 12.92;

    // Convert to XYZ (D65 illuminant)
    let x = (rr * 0.4124564 + gg * 0.3575761 + bb * 0.1804375) / 0.95047;
    let y = (rr * 0.2126729 + gg * 0.7151522 + bb * 0.0721750);
    let z = (rr * 0.0193339 + gg * 0.1191920 + bb * 0.9503041) / 1.08883;

    // XYZ to LAB
    const epsilon = 0.008856;
    const kappa = 903.3;
    x = x > epsilon ? Math.cbrt(x) : (kappa * x + 16) / 116;
    y = y > epsilon ? Math.cbrt(y) : (kappa * y + 16) / 116;
    z = z > epsilon ? Math.cbrt(z) : (kappa * z + 16) / 116;

    return {
      l: 116 * y - 16,
      a: 500 * (x - y),
      b: 200 * (y - z),
    };
  }

  // CIEDE2000 color difference
  function deltaE2000(lab1, lab2) {
    const { l: L1, a: a1, b: b1 } = lab1;
    const { l: L2, a: a2, b: b2 } = lab2;

    const avgL = (L1 + L2) / 2;
    const c1 = Math.sqrt(a1 * a1 + b1 * b1);
    const c2 = Math.sqrt(a2 * a2 + b2 * b2);
    const avgC = (c1 + c2) / 2;

    const g = 0.5 * (1 - Math.sqrt(Math.pow(avgC, 7) / (Math.pow(avgC, 7) + Math.pow(25, 7))));
    const a1p = a1 * (1 + g);
    const a2p = a2 * (1 + g);

    const c1p = Math.sqrt(a1p * a1p + b1 * b1);
    const c2p = Math.sqrt(a2p * a2p + b2 * b2);
    const avgCp = (c1p + c2p) / 2;

    let h1p = Math.atan2(b1, a1p) * (180 / Math.PI);
    if (h1p < 0) h1p += 360;
    let h2p = Math.atan2(b2, a2p) * (180 / Math.PI);
    if (h2p < 0) h2p += 360;

    let avgHp;
    if (Math.abs(h1p - h2p) > 180) {
      avgHp = (h1p + h2p + 360) / 2;
    } else {
      avgHp = (h1p + h2p) / 2;
    }

    const T = 1
      - 0.17 * Math.cos(((avgHp - 30) * Math.PI) / 180)
      + 0.24 * Math.cos(((2 * avgHp) * Math.PI) / 180)
      + 0.32 * Math.cos(((3 * avgHp + 6) * Math.PI) / 180)
      - 0.20 * Math.cos(((4 * avgHp - 63) * Math.PI) / 180);

    let dhp;
    if (Math.abs(h2p - h1p) <= 180) {
      dhp = h2p - h1p;
    } else if (h2p - h1p > 180) {
      dhp = h2p - h1p - 360;
    } else {
      dhp = h2p - h1p + 360;
    }

    const dLp = L2 - L1;
    const dCp = c2p - c1p;
    const dHp = 2 * Math.sqrt(c1p * c2p) * Math.sin((dhp / 2) * (Math.PI / 180));

    const sL = 1 + (0.015 * Math.pow(avgL - 50, 2)) / Math.sqrt(20 + Math.pow(avgL - 50, 2));
    const sC = 1 + 0.045 * avgCp;
    const sH = 1 + 0.015 * avgCp * T;

    const dTheta = 30 * Math.exp(-Math.pow((avgHp - 275) / 25, 2));
    const rc = 2 * Math.sqrt(Math.pow(avgCp, 7) / (Math.pow(avgCp, 7) + Math.pow(25, 7)));
    const rt = -Math.sin((2 * dTheta * Math.PI) / 180) * rc;

    return Math.sqrt(
      Math.pow(dLp / sL, 2) +
      Math.pow(dCp / sC, 2) +
      Math.pow(dHp / sH, 2) +
      rt * (dCp / sC) * (dHp / sH)
    );
  }

  // Pre-compute LAB values for all Pantone colors
  const pantoneLabCache = PANTONE_COLORS.map(([name, hex]) => {
    const { r, g, b } = hexToRgb(hex);
    return { name, hex, lab: rgbToLab(r, g, b) };
  });

  // Find the closest Pantone color
  function findClosestPantone(hex) {
    const { r, g, b } = hexToRgb(hex);
    const inputLab = rgbToLab(r, g, b);

    let bestMatch = null;
    let bestDelta = Infinity;

    for (const entry of pantoneLabCache) {
      const delta = deltaE2000(inputLab, entry.lab);
      if (delta < bestDelta) {
        bestDelta = delta;
        bestMatch = entry;
      }
    }

    return {
      name: `PANTONE ${bestMatch.name}`,
      hex: bestMatch.hex,
      deltaE: bestDelta.toFixed(2),
    };
  }

  // Validate hex input
  function isValidHex(hex) {
    return /^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(hex);
  }

  // DOM setup
  function init() {
    const container = document.getElementById('hex-to-pantone-tool');
    if (!container) return;

    const hexInput = container.querySelector('#hex-input');
    const hexHash = container.querySelector('.htp-hash');
    const colorPreviewInput = container.querySelector('#color-preview-input');
    const colorPreviewResult = container.querySelector('#color-preview-result');
    const resultSection = container.querySelector('.htp-result');
    const pantoneName = container.querySelector('#pantone-name');
    const pantoneHex = container.querySelector('#pantone-hex');
    const matchBarFill = container.querySelector('#match-bar-fill');
    const matchBadge = container.querySelector('#match-badge');
    const matchDesc = container.querySelector('#match-desc');
    const convertBtn = container.querySelector('#convert-btn');
    const colorPicker = container.querySelector('#color-picker');
    const errorMsg = container.querySelector('.htp-error');

    function getMatchQuality(deltaE) {
      const de = parseFloat(deltaE);
      if (de < 1) return {
        label: 'Exact Match',
        desc: 'These colors are virtually identical — the difference is imperceptible to the human eye.',
        pct: 100, color: '#2ecc71', bg: 'rgba(46,204,113,0.1)', border: 'rgba(46,204,113,0.2)'
      };
      if (de < 2) return {
        label: 'Excellent Match',
        desc: 'Extremely close — only a trained eye could spot a difference under ideal lighting.',
        pct: 90, color: '#27ae60', bg: 'rgba(39,174,96,0.1)', border: 'rgba(39,174,96,0.2)'
      };
      if (de < 3.5) return {
        label: 'Very Good Match',
        desc: 'A very close match. Most people would not notice the difference in everyday use.',
        pct: 75, color: '#f39c12', bg: 'rgba(243,156,18,0.1)', border: 'rgba(243,156,18,0.2)'
      };
      if (de < 5) return {
        label: 'Good Match',
        desc: 'A noticeable but acceptable difference. This is the closest available Pantone Solid Coated color.',
        pct: 60, color: '#e67e22', bg: 'rgba(230,126,34,0.1)', border: 'rgba(230,126,34,0.2)'
      };
      if (de < 8) return {
        label: 'Approximate Match',
        desc: 'There is a visible difference between these colors. Consider consulting a Pantone swatch book for best results.',
        pct: 40, color: '#e74c3c', bg: 'rgba(231,76,60,0.1)', border: 'rgba(231,76,60,0.2)'
      };
      return {
        label: 'Rough Match',
        desc: 'This HEX color does not have a close Pantone Solid Coated equivalent. The closest option is shown above.',
        pct: 20, color: '#c0392b', bg: 'rgba(192,57,43,0.1)', border: 'rgba(192,57,43,0.2)'
      };
    }

    function doConvert() {
      const rawVal = hexInput.value.trim();
      const hex = rawVal.replace(/^#/, '');

      if (!isValidHex(hex)) {
        errorMsg.style.display = 'block';
        resultSection.style.display = 'none';
        return;
      }

      errorMsg.style.display = 'none';
      const fullHex = hex.length === 3
        ? hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2]
        : hex;

      colorPreviewInput.style.backgroundColor = `#${fullHex}`;
      colorPicker.value = `#${fullHex}`;

      const result = findClosestPantone(fullHex);
      pantoneName.textContent = result.name;
      pantoneHex.textContent = `#${result.hex}`;

      const quality = getMatchQuality(result.deltaE);
      matchBarFill.style.width = quality.pct + '%';
      matchBarFill.style.backgroundColor = quality.color;
      matchBadge.textContent = quality.label;
      matchBadge.style.backgroundColor = quality.bg;
      matchBadge.style.color = quality.color;
      matchBadge.style.border = '1px solid ' + quality.border;
      matchDesc.textContent = quality.desc;

      colorPreviewResult.style.backgroundColor = `#${result.hex}`;
      resultSection.style.display = 'block';

      // Update input to show normalized value
      hexInput.value = fullHex.toUpperCase();
    }

    convertBtn.addEventListener('click', doConvert);
    hexInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') doConvert();
    });

    // Live preview as user types (strip # if pasted)
    hexInput.addEventListener('input', function () {
      if (hexInput.value.includes('#')) {
        hexInput.value = hexInput.value.replace(/#/g, '');
      }
      const val = hexInput.value.trim();
      if (isValidHex(val) && val.length >= 3) {
        const fullHex = val.length === 3
          ? val[0]+val[0]+val[1]+val[1]+val[2]+val[2]
          : val;
        colorPreviewInput.style.backgroundColor = `#${fullHex}`;
        colorPicker.value = `#${fullHex}`;
      }
    });

    // Color picker integration
    colorPicker.addEventListener('input', function () {
      const hex = colorPicker.value.replace('#', '').toUpperCase();
      hexInput.value = hex;
      colorPreviewInput.style.backgroundColor = colorPicker.value;
      doConvert();
    });

    // Clicking the hash symbol focuses the input
    hexHash.addEventListener('click', function () {
      hexInput.focus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
